import React, { FC, useCallback, useEffect, useState } from 'react'
import {
  Text,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalCloseButton,
  Flex,
  Checkbox,
} from '@chakra-ui/react'
import { useUserContext } from '../../../contexts/UserContext'

export const CLOSE_TABS_MODAL_SUPPRESSION_KEY = 'CLOSE_TABS_MODAL_SUPPRESSION'

interface Props {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

const ProjectCloseTabsConfirmationModal: FC<Props> = (props) => {
  const { isOpen, onCancel, onConfirm } = props
  const { captureAnalytics } = useUserContext()
  const [suppress, setSuppressed] = useState(false)

  useEffect(() => {
    setSuppressed(false)
  }, [isOpen, setSuppressed])

  const onSuppressChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSuppressed(event.target.checked)
      captureAnalytics('project_detail_dashboard:project_urls_close:suppress_confirmation_change', {
        checked: event.target.checked,
      })
    },
    [setSuppressed, captureAnalytics],
  )

  const saveSuppressionInLocalStorage = useCallback(() => {
    if (suppress) {
      localStorage.setItem(CLOSE_TABS_MODAL_SUPPRESSION_KEY, 'true')
    }
  }, [suppress])

  return (
    <Modal isCentered isOpen={isOpen} onClose={onCancel} size="lg">
      <ModalOverlay />
      <ModalContent borderRadius={'16px'}>
        <ModalHeader>Close all tabs?</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="16px" color="black">
            {`Any open tabs from this folder will be closed. This action doesn't change the folder contents.`}
          </Text>
          <Flex alignItems="center" mt="24px">
            <Checkbox
              id="suppressCloseTabs"
              checked={suppress}
              colorScheme="black"
              onChange={onSuppressChange}
            >
              Don&apos;t show this message again
            </Checkbox>
          </Flex>
        </ModalBody>
        <ModalFooter mt="16px">
          <Button
            height={'36px'}
            size="md"
            variant="outline"
            borderRadius="100px"
            paddingRight="24px"
            paddingLeft="24px"
            color={'black'}
            border="1px solid #A7A7A7"
            fontWeight={500}
            _hover={{
              backgroundColor: '#EBEBEB',
            }}
            onClick={() => {
              saveSuppressionInLocalStorage()
              onCancel()
            }}
            autoFocus
          >
            Keep open
          </Button>
          <Button
            ml="8px"
            height={'36px'}
            size="md"
            variant="solid"
            borderRadius="100px"
            paddingRight="24px"
            paddingLeft="24px"
            backgroundColor={'black'}
            color={'white'}
            fontWeight={500}
            _hover={{
              backgroundColor: '#585858',
            }}
            _disabled={{
              backgroundColor: '#D5D5D5',
              color: '#ffffff',
            }}
            onClick={() => {
              saveSuppressionInLocalStorage()
              onConfirm()
            }}
            autoFocus
          >
            Close tabs
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ProjectCloseTabsConfirmationModal
